import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "common/api/BaseQuery";
import { CustomLandingPage } from "../types/event.type";
import { FilterProduct, ProductJson } from "../types/product.type";

export const eventApi = createApi({
	reducerPath: "eventApi",
	baseQuery: baseQuery(false),
	endpoints: (builder) => ({
		// Api Public
		getSetingEvent: builder.query<CustomLandingPage, string>({
			query(params) {
				return {
					url: `/settings/public/${params}`,
				};
			},
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSetingEventQuery } = eventApi;
